import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  rewards: [],
  currentStep: 1,
};

const rewardTimelineSlice = createSlice({
  name: "rewardTimeline",
  initialState,
  reducers: {
    setRewards: (state, action) => ({
      ...state,
      rewards: action.payload,
    }),
    setCurrentStep: (state, action) => ({
      ...state,
      currentStep: action.payload,
    }),
  },
});

export const { setRewards, setCurrentStep } = rewardTimelineSlice.actions;
export default rewardTimelineSlice;
